import type { useAuthStore } from '@/stores/authStore';

type CompanyInfo = ReturnType<typeof useAuthStore.getState>['companies'][number];

/** Sentinel Select value for the pinned "All companies (consolidated)" option. */
export const CONSOLIDATED_OPTION = '__consolidated__';
export const CONSOLIDATED_LABEL = 'All companies (consolidated)';

/**
 * Consolidation is a report scope, not a company entity (is_group_level is a per-membership
 * flag; every `companies` entry is a real company). So the pinned option navigates to Finance →
 * Reports (P&L) with `?scope=group`; ReportsPage reads the `scope` param.
 */
export const CONSOLIDATED_PATH = '/finance?scope=group#reports.financial';

/** Individual companies, alphabetical (case-insensitive), never mutating the store array. */
export function sortCompanies(companies: CompanyInfo[]): CompanyInfo[] {
  return [...companies].sort((a, b) =>
    (a.company_name || '').localeCompare(b.company_name || '', undefined, { sensitivity: 'base' }),
  );
}

/** Group currency is shown only when every company shares one base currency. */
export function groupCurrency(companies: CompanyInfo[]): string | null {
  const set = new Set(companies.map((c) => c.base_currency).filter(Boolean));
  return set.size === 1 && companies.every((c) => c.base_currency) ? [...set][0]! : null;
}
